import FtSaleshFilter from "@/models/payload/ft-salesh-filter";
import FSalesmanFilter from "@/models/payload/f-salesman-filter";
import FCustomerFilter from "@/models/payload/f-customer-filter";
import FMaterialFilter from "@/models/payload/f-material-filter";

export const filter = {
  namespaced: true,
  state: {
      salesInvoiceFilter: new FtSaleshFilter(),
      cloudOrderFilter: new FtSaleshFilter(),

      callPlanFilter: new FtSaleshFilter(),
      callActFilter: new FtSaleshFilter(),

      salesmanFilter: new FSalesmanFilter(),
      customerFilter: new FCustomerFilter(),
      materialFilter: new FMaterialFilter(),

      ftSaleshFilter: new FtSaleshFilter(),

    filterOrderDateFrom: '',
    filterOrderDateTo: '',

    filterFdivisions: [],
    filterFsalesmans: [],
    filterFstores: [],
    filterFexpedisies:[],
    filterFmaterials: [],
    filterEstatusPengiriman: [],
    filterFwarehouses: [],

    filterByGroupMaterialOrdered:[],
    itemsGroupMaterialOrdered:[],

  },
  actions: {
      updateSalesInvoiceFilter({commit}, payload){
          commit('mutateSalesInvoiceFilter', payload)
      },
      updateCloudOrderFilter({commit}, payload){
          commit('mutateCloudOrderFilter', payload)
      },
      updateCallPlanFilter({commit}, payload){
          commit('mutateCallPlanFilter', payload)
      },
      updateCallActFilter({commit}, payload){
          commit('mutateCallActFilter', payload)
      },

      updateSalesmanFilter({commit}, payload){
          commit('mutateSalesmanFilter', payload)
      },
      updateCustomerFilter({commit}, payload){
          commit('mutateCustomerFilter', payload)
      },
      updateMaterialFilter({commit}, payload){
          commit('mutateMaterialFilter', payload)
      },

    ftSaleshFilterUpdate({commit}, payload){
      commit('ftSaleshFilterMutate', payload)
    },

    filterOrderDateFromUpdate({commit}, payload){
      commit('filterOrderDateFromMutate', payload)
    },
    filterOrderDateToUpdate({commit}, payload){
      commit('filterOrderDateToMutate', payload)
    },

    filterFdivisionsUpdate({commit}, payload){
      commit('filterFdivisionsMutate', payload)
    },
    filterFsalesmansUpdate({commit}, payload){
      commit('filterFsalesmansMutate', payload)
    },
    filterFstoresUpdate({commit}, payload){
      commit('filterFstoresMutate', payload)
    },
    filterFexpedisiesUpdate({commit}, payload){
      commit('filterFexpedisiesMutate', payload)
    },
    filterFmaterialsUpdate({commit}, payload){
      commit('filterFmaterialsMutate', payload)
    },
    filterEstatusPengirimanUpdate({commit}, payload){
      commit('filterEstatusPengirimanMutate', payload)
    },
    filterFwarehousesUpdate({commit}, payload){
      commit('filterFwarehousesMutate', payload)
    },

    filterByGroupMaterialOrderedUpdate({commit}, payload){
      commit('filterByGroupMaterialOrderedMutate', payload)
    },
    itemsGroupMaterialOrderedUpdate({commit}, payload){
      commit('itemsGroupMaterialOrderedMutate', payload)
    },


  },
  mutations: {
      mutateSalesInvoiceFilter(state, payload){
          state.salesInvoiceFilter = payload
      },
      mutateCloudOrderFilter(state, payload){
          state.cloudOrderFilter = payload
      },
      mutateCallPlanFilter(state, payload){
          state.callPlanFilter = payload
      },
      mutateCallActFilter(state, payload){
          state.callActFilter = payload
      },

      mutateSalesmanFilter(state, payload){
          state.salesmanFilter = payload
      },
      mutateCustomerFilter(state, payload){
          state.customerFilter = payload
      },
      mutateMaterialFilter(state, payload){
          state.materialFilter = payload
      },

      ftSaleshFilterMutate(state, payload){
        state.ftSaleshFilter = payload
      },



    filterOrderDateFromMutate(state, payLoad){
      state.filterOrderDateFrom = payLoad
    },
    filterOrderDateToMutate(state, payLoad){
      state.filterOrderDateTo = payLoad
    },

    filterFdivisionsMutate(state, payLoad){
      state.filterFdivisions = payLoad
    },
    filterFsalesmansMutate(state, payLoad){
      state.filterFsalesmans = payLoad
    },
    filterFstoresMutate(state, payLoad){
      state.filterFstores = payLoad
    },
    filterFexpedisiesMutate(state, payLoad){
      state.filterFexpedisies = payLoad
    },
    filterFmaterialsUpdate(state, payLoad){
      state.filterFmaterials = payLoad
    },
    filterEstatusPengirimanMutate(state, payLoad){
      state.filterEstatusPengiriman = payLoad
    },
    filterFwarehousesMutate(state, payLoad){
      state.filterFwarehouses = payLoad
    },

    filterByGroupMaterialOrderedMutate(state, payLoad){
      state.filterByGroupMaterialOrdered = payLoad
    },
    itemsGroupMaterialOrderedMutate(state, payLoad){
      state.itemsGroupMaterialOrdered = payLoad
    },

  }

};
